var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50691 4.09367C5.11639 3.70315 4.48322 3.70315 4.0927 4.09367C3.70217 4.4842 3.70217 5.11736 4.0927 5.50789L8.58559 10.0008L4.0927 14.4937C3.70217 14.8842 3.70217 15.5174 4.0927 15.9079C4.48322 16.2984 5.11639 16.2984 5.50691 15.9079L9.9998 11.415L14.4927 15.9079C14.8832 16.2984 15.5164 16.2984 15.9069 15.9079C16.2974 15.5174 16.2974 14.8842 15.9069 14.4937L11.414 10.0008L15.9069 5.50789C16.2974 5.11736 16.2974 4.4842 15.9069 4.09367C15.5164 3.70315 14.8832 3.70315 14.4927 4.09367L9.9998 8.58657L5.50691 4.09367Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.c1583d7d9928d2c1fb92820ad3877fe7.svg";
export { ForwardRef as ReactComponent };